import { OpsLineEntity } from "domain/entity/OpsLine/OpsLineEntity";
import _ from "lodash";
import { axiosGetData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { OpsLineRepository } from "./OpsLineRepo";

export const OpsLineRepoImpl = (): OpsLineRepository => {
    const url = '/v1/opsLine'
    const getAllOpsLines = async (): Promise<OpsLineEntity[]> => {
        return axiosGetData(referenceAxiosInstance, url, []).then(res => {

            let opsLines: OpsLineEntity[] = [];
            if (res.data && res.data.length > 0) {
                opsLines = _.uniqBy(res.data, 'opsLine') as unknown as OpsLineEntity[]
            }

            return opsLines;
        }).catch(err => {
            return [];
        })
    }

    const getOpsLineForCombobox = async (): Promise<OpsLineEntity[]> => {
        return axiosGetData(referenceAxiosInstance, `${url}/combobox`, []).then(res => {

            let opsLines: OpsLineEntity[] = [];
            if (res.data && res.data.length > 0) {
                opsLines = _.uniqBy(res.data, 'opsLine') as unknown as OpsLineEntity[]
            }

            return opsLines;
        }).catch(err => {
            return [];
        })
    }

    return {
        getAllOpsLines: getAllOpsLines,
        getOpsLineForCombobox: getOpsLineForCombobox
    }
}